import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSanityTexts } from '../contexts/SanityTextsContext';

export const useCachedTexts = (category) => {
  const { i18n } = useTranslation();
  const { fetchTexts, textsCache } = useSanityTexts();
  const [texts, setTexts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTexts = async () => {
      // Check if already cached
      if (textsCache[category]) {
        setTexts(textsCache[category]);
        setLoading(false);
        return;
      }

      // Fetch if not cached
      setLoading(true);
      const data = await fetchTexts(category);
      if (data) {
        setTexts(data);
      }
      setLoading(false);
    };

    loadTexts();
  }, [category, fetchTexts, textsCache]);

  const getText = (key, fallback) => {
    const item = texts.find(t => t.key === key);
    if (!item) return fallback;
    return i18n.language === 'it' ? item.textIt : item.textEn;
  };

  return { texts, getText, loading };
};
